import i18n from 'i18next';
import {
    initReactI18next
} from 'react-i18next';
import zh from './locale/zh';
import en from './locale/en';
import ja from './locale/ja';
import ko from './locale/ko';


const lng = 'zh';
setTimeout(()=> {
    console.log('----zh', zh)
}, 100)

i18n.use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources: {
            zh: {
                translation: zh,
            },
            en: {
                translation: en,
            },
            ja: {
                translation: ja,
            },
            ko: {
                translation: ko,
            },
        },
        lng: lng,
        fallbackLng: lng,
        interpolation: {
            escapeValue: false,
        },
    });

export function getCurrentLanguage(){
  return i18n.language;
}


export default i18n
